import Vue from 'vue'
import GridItemWrapper from './editor/nodes/GridItemWrapper.vue'

Vue.component('GridItemV3', GridItemWrapper)
